import React from "react";
import DecisionTable from "./DecisionTable";

const QuickDecisionFramework = ({ data }) => {
    if (!data) return null;


    return (
        <div className="QuickDecisionFramework">
            <h5 className="title fw-bold">{data?.title}</h5>
            <DecisionTable data={data} />
        </div>
    );
};

export default QuickDecisionFramework;